import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@agconnections/grow-ui';
import useCropData from 'hooks/useCropData';

const cropFieldDefaultPropSetCrop = () => {};
const CropField = ({
  cropId,
  cropStyle = '',
  setCrop = cropFieldDefaultPropSetCrop
}) => {
  const { crops, loading } = useCropData(cropId);
  useEffect(() => {
    if (crops) {
      setCrop(crops);
    }
  }, [crops, setCrop]);
  return (
    <>
      {!loading ? (
        <span className={cropStyle}>{crops?.name}</span>
      ) : (
        <Spinner />
      )}
    </>
  );
};

CropField.propTypes = {
  cropId: PropTypes.string.isRequired,
  setCrop: PropTypes.func,
  cropStyle: PropTypes.string
};

export default CropField;
